/* eslint-disable jsx-a11y/autocomplete-valid */
// @ts-nocheck
import { EnvelopeIcon, UsersIcon } from '@heroicons/react/20/solid';
import { phoneCodes } from 'appConstants';
import { monthsObj } from 'appConstants';
import { phoneMask } from 'helpers/validation';
import { FormEvent, useState } from 'react';

import { RegisterPhoneCodeSelect } from '../FormElement';

export const PaymentStep = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneCode, setPhoneCode] = useState(
    phoneCodes.find((phone) => phone.code === '+36'),
  );
  const [email, setEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cvc, setCvc] = useState('');
  const [cardDate, setCardDate] = useState('');
  const [cardHolderName, setCardHolderName] = useState('');

  const dateFirstBilling = new Date(+Date.now() + 1555200000);

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <form onSubmit={submitHandler}>
      <div>
        <fieldset>
          <legend className="block text-sm font-medium leading-6 text-gray-900">
            Contact information
          </legend>
          <div className="relative mt-2 rounded-md shadow-sm">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              type="email"
              name="email"
              id="email"
              className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="relative mt-3 rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 flex items-center">
              <label htmlFor="country" className="sr-only">
                Country
              </label>
              <RegisterPhoneCodeSelect
                phoneCode={phoneCode}
                setPhoneCode={setPhoneCode}
              />
            </div>
            <input
              type="text"
              value={phoneNumber}
              //   onChange={(e) => setPhoneNumber(e.target.value)}
              onInput={(e) => {
                phoneMask(e, setPhoneNumber);
              }}
              required
              name="phone-number"
              id="phone-number"
              autoComplete="tel-national"
              className="block w-full rounded-md border-gray-300 pl-28 md:focus:border-indigo-500 md:focus:ring-indigo-500 sm:text-sm"
              placeholder="Phone Number"
            />
          </div>
        </fieldset>
      </div>
      <div>
        <fieldset className="mt-6">
          <legend className="block text-sm font-medium leading-6 text-gray-900">
            Card Details
          </legend>
          <div className="mt-2 -space-y-px rounded-md bg-white shadow-sm">
            <div>
              <label htmlFor="card-number" className="sr-only">
                Card number
              </label>
              <input
                type="text"
                name="card-number"
                id="card-number"
                autoComplete="cc-number"
                className="relative block w-full rounded-none rounded-t-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Card number"
                value={cardNumber}
                onChange={(e) => {
                  const x = e.target.value
                    .replace(/\D/g, '')
                    .match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
                  let newVal = x[1];
                  if (x[2]) {
                    newVal += ' ' + x[2];
                  }
                  if (x[3]) {
                    newVal += ' ' + x[3];
                  }
                  if (x[4]) {
                    newVal += ' ' + x[4];
                  }
                  setCardNumber(newVal);
                }}
              />
            </div>
            <div className="flex -space-x-px">
              <div className="w-1/2 min-w-0 flex-1">
                <label htmlFor="card-expiration-date" className="sr-only">
                  Expiration date
                </label>
                <input
                  type="text"
                  name="card-expiration-date"
                  id="card-expiration-date"
                  autoComplete="cc-exp"
                  className="relative block w-full rounded-none rounded-bl-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="MM / YY"
                  value={cardDate}
                  onChange={(e) => {
                    const x = e.target.value
                      .replace(/\D/g, '')
                      .match(/(\d{0,2})(\d{0,2})/);
                    let newVal = x[1];
                    if (x[2]) {
                      newVal += ' / ' + x[2];
                    }
                    setCardDate(newVal);
                  }}
                />
              </div>
              <div className="min-w-0 flex-1">
                <label htmlFor="card-cvc" className="sr-only">
                  CVC
                </label>
                <input
                  type="text"
                  name="card-cvc"
                  id="card-cvc"
                  className="relative block w-full rounded-none rounded-br-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="CVV/CVC"
                  value={cvc}
                  maxLength={3}
                  onChange={(e) => {
                    if (e.target.value.length <= 3) {
                      const newVal = e.target.value.replace(/\D/g, '');
                      setCvc(newVal);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="relative flex flex-grow items-stretch focus-within:z-10 mt-3">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
              <input
                type="text"
                name="billingName"
                id="card-holder-name"
                autoComplete="cname"
                className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Card holder name"
                value={cardHolderName}
                onChange={(e) => setCardHolderName(e.target.value)}
              />
            </div>
          </div>
        </fieldset>
        <fieldset className="mt-6 bg-white">
          <legend className="block text-sm font-medium leading-6 text-gray-900">
            Billing address
          </legend>
          <div className="mt-2 -space-y-px rounded-md shadow-sm">
            <div>
              <label htmlFor="country" className="sr-only">
                Country
              </label>
              <select
                id="country"
                name="country"
                autoComplete="country-name"
                className="relative block w-full rounded-none rounded-t-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              >
                <option>United States</option>
                <option>Canada</option>
                <option>Mexico</option>
              </select>
            </div>
            <div>
              <label htmlFor="address-line-1" className="sr-only">
                Address line 1
              </label>
              <input
                type="text"
                name="address-line-1"
                id="address-line-1"
                className="relative block w-full rounded-none border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Address line 1"
              />
            </div>
            <div>
              <label htmlFor="address-line-2" className="sr-only">
                Address line 2
              </label>
              <input
                type="text"
                name="address-line-2"
                id="address-line-2"
                className="relative block w-full rounded-none border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Address line 2"
              />
            </div>
            <div className="flex -space-x-px">
              <div className="w-1/2 min-w-0 flex-1">
                <label htmlFor="city" className="sr-only">
                  City
                </label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  className="relative block w-full rounded-none rounded-bl-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="City"
                />
              </div>
              <div className="min-w-0 flex-1">
                <label htmlFor="postal-code" className="sr-only">
                  ZIP / Postal code
                </label>
                <input
                  type="text"
                  name="postal-code"
                  id="postal-code"
                  autoComplete="postal-code"
                  className="relative block w-full rounded-none rounded-br-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="ZIP / Postal code"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <button
        type="submit"
        className="mt-6 rounded-md w-full bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        Start trial
      </button>
      <div className="text-xs text-gray-400 mt-3 text-center">
        After your trial ends, you will be charged €45.00 per month starting{' '}
        {monthsObj[dateFirstBilling.getMonth()]} {dateFirstBilling.getDate()},{' '}
        {dateFirstBilling.getFullYear()}. You can always cancel before then.
      </div>
    </form>
  );
};
